export class NewOfferEvent {}
